import { CertificationOut } from "api-client";
import DropdownCheckbox from "components/DropdownCheckbox";
import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { searchStore } from "features/ProductSearch/SearchStore";
import { conformityStore } from "../../../store/ConformityStore.ts";

export default observer(function CertificationFilter({
  selected,
  setSelected,
  removingItem,
  handleRemoveItem,
}: {
  selected?: CertificationOut[];
  setSelected: React.Dispatch<React.SetStateAction<CertificationOut[]>>;
  removingItem?: CertificationOut;
  handleRemoveItem?: () => void;
}) {
  const { t } = useTranslation();

  const onChange = (value: CertificationOut[]) => setSelected(value);

  React.useEffect(() => {
    (async () => {
      await conformityStore.fetchCertificationData();
      searchStore.setFilterOptions({
        ...searchStore.filtersOptions,
        certifications: conformityStore.certificationOptions.filter(
          (item) => item.name !== ""
        ),
      });
    })();
  }, []);

  if (!searchStore.filtersOptions.certifications) return <></>;
  return (
    <DropdownCheckbox<CertificationOut>
      displayKey={"name"}
      required={true}
      handleSelect={onChange}
      labelName={t("mapping.certification")}
      name="certifications"
      items={searchStore.filtersOptions.certifications.filter(
        (item) => item.name !== "Keine"
      )}
      removeSelected={removingItem}
      handleRemoveSelected={handleRemoveItem}
      containerClassName="mr-0 sm:mr-3 min-w-[146px]"
      checkedItems={selected}
      optionsClassName="z-40 !max-w-fit"
      noMargin
    />
  );
});
